import React, { Component } from 'react';
import { connect } from 'react-redux';
import GrowthCharsMetricsRow from './GrowthCharsMetricsRow';
import {
  setActivePane, setAllGrowthChars
} from '../../../actions';
import Select from 'react-select';
import './GrowthCharsMetricTable.css';
import i18n from '../../../i18n';

const customStyles = {
  control: (base) => ({
    ...base,
    borderRadius: 0,
    border: '1px solid #050139', // default border color
    boxShadow: 'none',
  }),
  option: (provided) => ({
    ...provided,
    color: '#5b6770',
    fontSize: 14,
    borderRadius: 0,
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: '#050139',
      color: 'white',
    },

  }),
  menu: base => ({
    ...base,
    borderRadius: 0
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 100ms';
    return { ...provided, opacity, transition };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: '#050139',
  }),

};

class GrowthCharsMetricTable extends Component {

  constructor(props) {
    super(props);

    this.state = {
      chartType: { value: 'SalesGrowth', label: 'Sales Growth' },
    };
  }

  asOfDate() {
    const {
      data
    } = this.props;
    const fundsWithAggs = data.filter((x) => x.aggregateFundamentals !== null);
    if (fundsWithAggs.length > 0) {
      const fund = fundsWithAggs[0];
      const value = fund['aggregateFundamentals'][fund['aggregateFundamentals'].length - 1];
      return new Date(value.date).toLocaleString().split(',')[0].split(' ')[0];
    } else {
      return '';
    }
  }


  viewChars() {
    this.props.setAllGrowthChars(false);
  }

  handleChartTypeChange = chartType => {
    this.setState({ chartType: chartType });
  };

  // create the rows
  renderGrowthTableRows() {
    const {
      data,
      wtRegion,
    } = this.props;

    const chartType = this.state.chartType.value;

    return data.map((fund) => {
      return (
        <GrowthCharsMetricsRow key={fund.externalID} fund={fund} wtRegion={wtRegion} chartType={chartType} />
      );
    });
  }

  // create the header
  renderGrowthTableHeader() {
    const chartTypeLabel = this.state.chartType.label
    return (
      <thead>
        <tr>
          <th colSpan="2" className='textLeft'>GROWTH CHARACTERISTICS {i18n.t('as of')} {this.asOfDate()}</th>
          <th colSpan="3" className='borderleft borderbottom textCenter'>{i18n.t('Median')} {chartTypeLabel} </th>
          <th colSpan="3" className='borderleft borderbottom textCenter'> {i18n.t('Weighted Average ')} {chartTypeLabel} </th>
        </tr>
        <tr>
          <th className='textLeft'>{i18n.t('Ticker')}</th>
          <th className='textLeft'>{i18n.t('Fund')}</th>

          {/* Median  */}
          <th className='textCenter'>{i18n.t('1-Year')}</th>
          <th className='textCenter'>{i18n.t('3-Year')}</th>
          <th className='textCenter'>{i18n.t('5-Year')}</th>
          {/* WeightedAverage  */}
          <th className='textCenter'>{i18n.t('1-Year')}</th>
          <th className='textCenter'>{i18n.t('3-Year')}</th>
          <th className='textCenter'>{i18n.t('5-Year')}</th>
        </tr>
      </thead>
    );
  }

  render() {
    const {
      chartType,
    } = this.state;

    return (
      <div className='growth-chars-metrics'>
        <div className='row' style={{ marginBottom: '20px' }}>
          <div className='col-md-3' style={{ textAlign: 'center', paddingRight: '3px' }}>
            <Select
              options={[
                { value: 'DividendGrowth', label: 'Dividend Growth' },
                { value: 'SalesGrowth', label: 'Sales Growth' },
                { value: 'EBITDAGrowth', label: 'EBITDA Growth' },
                { value: 'EarningsGrowth', label: 'Earnings Growth' },
                { value: 'OCFGrowth', label: 'Operating Cash Flow Growth' },
                { value: 'FCFGrowth', label: 'Free Cash Flow Growth' },
              ]}
              styles={customStyles}
              value={chartType}
              onChange={this.handleChartTypeChange}
              defaultValue={[{ value: 'SalesGrowth', label: 'Sales Growth' }]}
            />
          </div>
        </div>

        <div className='table-responsive'>
          <table className='table tableFC'>
            {this.renderGrowthTableHeader()}
            <tbody>{this.renderGrowthTableRows()}</tbody>
          </table>
          <br />
        </div>
        <div style={{ marginTop: '15px' }}>
          <a className='tickerLinkTeal' onClick={() => this.viewChars()} href=''>View growth characteristics page.</a>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: state.fundData.perfData,
    params: state.params,
    wtRegion: state.params.wtRegion,
  };
}

export default connect(mapStateToProps,
  {
    setActivePane,
    setAllGrowthChars
  }
)(GrowthCharsMetricTable);
